import "../main.css";

export default function PalavraChaveDemografica() {
  return (
    <div>
      <ul className="nav categories-nav nav-pills flex-column" role="navigation">
        <li className="nav-item open">
          <h3>Palavras-chave</h3>

          <ul className="nav nav-pills flex-column">
            <li className="keypass-container">
              <a className=" keypass" href="/variaveis-demograficas#rendafamiliar">
                renda familiar
              </a>
              <a className="keypass" href="/variaveis-demograficas#rendaindividual">
                renda individual
              </a>
              <a className="keypass" href="/variaveis-demograficas#sexo">
                sexo
              </a>
              <a className="keypass" href="/variaveis-demograficas#idade">
                idade
              </a>
              <a className="keypass" href="/variaveis-demograficas#profissao">
                profissão
              </a>
              <a className="keypass" href="/variaveis-demograficas#obito">
                óbito
              </a>
              <a className="keypass" href="/variaveis-demograficas#peprelacionado">
                qtde pep relacionado
              </a>
              <a className="keypass" href="/variaveis-demograficas#receitafed">
                status receita federal
              </a>
              <a className="keypass" href="/variaveis-demograficas#estadocivil">
                estado civil
              </a>
              <a className="keypass" href="/variaveis-demograficas#aponsentado">
                aponsentado
              </a>
              <a className="keypass" href="/variaveis-demograficas#participacao">
                participação em empresas
              </a>
              <a className="keypass" href="/variaveis-demograficas#bolsafamilia">
                bolsa familia
              </a>
              <a className="keypass" href="/variaveis-demograficas#auxilio">
                auxilio emergencial
              </a>
              <a className="keypass" href="/variaveis-demograficas#flagpep">
                flag pep
              </a>
              <a className="keypass" href="/variaveis-demograficas#escolaridade">
                escolaridade
              </a>

            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}
